import { BxNotification } from '@/app/interfaces/notification.interface';
import { NotificationService } from '@/app/services/notification/notification.service';
import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notification-detail',
  standalone: true,
  imports: [CommonModule, MatCardModule],
  templateUrl: './notification-detail.component.html',
  styleUrl: './notification-detail.component.css',
})
export class NotificationDetailComponent implements OnInit {
  allNotifications: BxNotification[] = [];
  @Input() details: BxNotification | null = null;

  constructor(
    private notificationService: NotificationService,
    private router: Router,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.notificationService.getAllNotifications().subscribe({
      next: (v: any) => {
        if (v && v.data.length > 0) {
          this.allNotifications = v.data;
        }
      },
    });
  }

  selectedNotification: BxNotification | null = null;

  markAsRead(notification: BxNotification) {
    // TODO: send back request to make notification read
    notification.is_read = true;
  }

  selectNotification(notification: BxNotification) {
    this.selectedNotification = notification;
  }

  // getter
  get parsedSelectedNotificationData() {
    const data = JSON.parse(this.details.data);
    return {
      ...data,
      notes: this.sanitizer.bypassSecurityTrustHtml(data.notes),
    };
  }
}
